<template>
  <div class="img-view" @click="handleClick">
    <img
      class="img-small"
      v-on="$listeners"
      v-bind="$attrs">
    <!-- 图片放大位置重置：v-if="dialogVisible" -->
    <el-dialog
      top="30px"
      width="700px"
      :fullscreen="false"
      custom-class="dialog-image"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      v-if="dialogVisible"
      :modal="false"
      v-dialogDrag>
      <img draggable="true" :style="transfromClass(this.$attrs.src)" :src="this.$attrs.src" class="img-big" />
      <div class="transfrom-wrap" v-if="transfrom">
        <el-button class="transfrom" @click="transfromPicLeft" type="primary">左旋转</el-button>
        <el-button class="transfrom" @click="transfromPicRight" type="primary">右旋转</el-button>
        <!-- <el-button class="transfrom" @click="moreBig" type="primary">放大</el-button>
        <el-button class="transfrom" @click="resetBig" type="primary">重置</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'imgView',
  props: {
    transfrom: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogVisible: false,
      rotate: 0,
      widthBig: 500,
      heightBig: 500
    }
  },
  methods: {
    handleClick () {
      this.dialogVisible = true
    },
    transfromClass: function (src) {
      return {
        transform: `rotate(${this.rotate}turn)`,
        width: `${this.widthBig}px`,
        height: `${this.heightBig}px`
      }
    },
    transfromPicLeft () {
      this.rotate -= 0.25
    },
    transfromPicRight () {
      this.rotate += 0.25
    },
    moreBig () {
      this.widthBig += 50
      this.heightBig += 50
    },
    resetBig () {
      this.rotate = 0
      this.widthBig = 500
      this.heightBig = 500
    }
  }
}
</script>

<style lang="scss" scoped>
.img-view {
  position: relative;
  .img-small {
    cursor: pointer;
    width: 100%;
    height: 100%;
  }

  .mask {
    height: 100%;
    width: 100%;
    position: absolute;
    background-color: rgba(0, 0, 0, .0);
    transition: background-color .5s;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      visibility: hidden;
      font-size: 20px;
      color: #fff;
    }
  }
  &:hover .mask {
    background-color: rgba(0, 0, 0, .5);
    i {
      visibility: visible;
    }
  }
  .img-big {
    width: 100px;
    height: auto;
  }
}
</style>

<style lang="scss">
.dialog-image{
  .img-big {
  display: block;
  margin: 0 auto;
  width: auto;
  height: 500px;
  transition: 0.3s;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.transfrom-wrap{
  position: fixed;
  bottom: 0;
  left: 50%;
  margin-left: -190px;
  display: flex;
  justify-content: center;
  width: 380px;
  .transfrom{
    margin: 10px;
  }
}
.el-icon-close{
  font-size: 50px;
}
}
</style>
